import React from 'react';
import {
    withStyles,
    Grid,
    Button,
    ButtonBase,
    Typography,
    IconButton,
    Snackbar,
} from '@material-ui/core'; 
 
import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';
import IntegralBuy from './IntegralBuy';
import IntegralSign from './IntegralSign';
import AppData from '../../model/AppData';

const ICON_RULE = require("../../images/icons/guize.png");
const ICON_DETAIL = require("../../images/icons/mingxi.png");
const ICON_SPORTS = require("../../images/icons/sports-medal.png");
const ICON_HOT = require("../../images/icons/shop_remen.png");
const ICON_ARROW = require("../../images/icons/jiantou.png");
const ICON_GIFT = require("../../images/icons/libao.png");


const daysAward = [
    { name: 'Web', day: 1, date: '', sign_status: 0 },
    { name: 'Thu', day: 2, date: '', sign_status: 0 },
    { name: 'Fri', day: 3, date: '', sign_status: 0 },
    { name: 'Sat', day: 4, date: '', sign_status: 0 },
    { name: 'Sun', day: 5, date: '', sign_status: 0 },
    { name: 'Man', day: 6, date: '', sign_status: 0 },
    { name: 'Tue', day: 7, date: '', sign_status: 0 },
]

class IntegralWallet extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            data: [],
            dayList: [],
            showGift: false,
            goodsList: [],
            showSign: false,
            showBuy: false,
            curGood: null,
            snackopened: false,
            message: '',
            page: 1,
            total: 0,
            avatar: ''
        };
        document.body.style.overflow = 'scroll'
    }

    componentDidMount() {
        let { os } = this.props.match.params;
        if (os && os != '') {
            AppData.os = os
        }
        else {
            AppData.os = 'h5'
        }
        const { page } = this.state;
        this.encryptionScoreHome();
        this.encryptionGiftList(page);
        AppUtils.YMPush('MAIN', 'IntegralWallet');
        this.setStoreDay()
        this.getAvatar()

    }


    componentWillUnmount() {
        this.setState = () => false;
    }

    setStoreDay = () => {
        var date = new Date;
        var d = date.getDay() //今天的日期
        AppUtils.setStorageItem('day', d)
    }

    //获取用户头像
    getAvatar = async () => {
        let { os, token, uid, customerId } = this.props.match.params;

        AppData.me.token = token;
        AppData.me.customer_id = customerId ? customerId : uid;
        let result = await Apis.encryptionShowCustomer();
        if (result.code == 200) {
            this.setState({
                avatar: result.data.portrait
            })
        }
    }

    encryptionScoreHome = async () => {
        let { os, token, uid, channel, customerId } = this.props.match.params;
        let result = await Apis.encryptionScoreHome(customerId ? customerId : uid, token, channel);
        console.log('encryptionScoreHome', result);
        if (result.code == 200) {
            let showGift = true;
            let max = 0;
            for (let i = 0; i < daysAward.length; i++) {
                for (let j = 0; j < result.data.day_list.length; j++) {
                    if (daysAward[i].day == result.data.day_list[j].day) {
                        daysAward[i].date = result.data.day_list[j].date;
                        daysAward[i].sign_status = result.data.day_list[j].sign_status;
                        if (daysAward[i].sign_status == 1) {
                            max = j;
                        }
                    }
                }
            }

            for (let i = 0; i <= max; i++) {
                if (daysAward[i].sign_status == 0) {
                    showGift = false;
                }
            }
            let sign_in_status = result.data.sign_in_status == 0;
            this.setState({ data: result.data, dayList: daysAward, showGift: showGift, showSign: sign_in_status });
        }
    }

    encryptionGiftList = async (page) => {
        let { os, token, uid, channel, customerId } = this.props.match.params;
        let result = await Apis.encryptionGiftList(customerId ? customerId : uid, token, channel, 0, 50, page);
        console.log('encryptionGiftList', result);
        if (result.code == 200) {
            let { goodsList } = this.state;
            for (let i = 0; i < result.data.list.length; i++) {
                goodsList.push(result.data.list[i]);
            }
            this.setState({ goodsList: goodsList, total: result.data.total });
        }
    }


    onExchange = async (good) => {
        this.setState({ showBuy: false })
        let { os, token, uid, channel, customerId } = this.props.match.params;
        let result = await Apis.encryptionUserBuyGift(customerId, token, channel, good.id, 1);
        console.log('encryptionGiftList', result);
        if (result.code == 200) {
            this.setState({ showBuy: false, snackopened: true, message: result.msg });
            let { os, token, uid, channel, nav } = this.props.match.params;
            if (nav && nav == 1) {
                nav = 1
            } else {
                nav = 0
            }
            this.props.history.push({ pathname: '/integralexchange/' + channel + '/' + uid + "/" + token + "/" + nav + "/" + result.data.total_score + "/" + result.data.score });

        } else {
            this.setState({ showBuy: false, snackopened: true, message: result.msg })
        }
    }

    onMyGoodList = () => {
        let { os, token, uid, channel, nav } = this.props.match.params;
        if (nav && nav == 1) {
            nav = 1
        } else {
            nav = 0
        }
        this.props.history.push({ pathname: '/integralgoods/' + channel + '/' + uid + "/" + token + "/" + nav });
    }

    onRuleClick = () => {
        let { nav } = this.props.match.params;

        if (nav && nav == 1) {
            nav = 1
        } else {
            nav = 0
        }
        // ToName(this.props, '/integralrule/' + nav)
        this.props.history.push({ pathname: '/integralrule/' + nav })
    }

    onDetailClick = () => {
        let { os, token, uid, channel, nav } = this.props.match.params;
        if (nav && nav == 1) {
            nav = 1
        } else {
            nav = 0
        }
        this.props.history.push({ pathname: '/integraldetail/' + channel + '/' + uid + "/" + token + "/" + nav });
    }

    onItemClick = (item) => {
        this.setState({ showBuy: true, curGood: item })
    }

    renderGift = (day, status) => {
        const { classes } = this.props;
        const { showGift } = this.state;
        if (day == 7 && showGift) {
            return (
                <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.dayItem1}>
                    <img src={ICON_GIFT} style={{ width: 28, height: 28 }}></img>
                </Grid>
            );
        }

        if (status == 1) {
            return (
                <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.dayItem}>
                    <Typography style={{ fontSize: 12, color: "#0D0D0D" }}>{day}</Typography>
                </Grid>
            );
        }
        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.dayItem1}>
                <Typography style={{ fontSize: 12, color: "#0D0D0D" }}>{day}</Typography>
            </Grid>
        );

    }

    renderItem = (data) => {
        console.log('data----', data);
        const { classes } = this.props;
        return (
            <Grid container direction='row' justifyContent='flex-start' wrap='wrap'  >
                {
                    data.length > 0 && data.map((item, i) => (
                        <ButtonBase key={i} onClick={() => this.onItemClick(item)}>
                            <Grid container direction='column' className={classes.goodItem}>
                                <Grid container direction='row' justifyContent='flex-end' style={{ width: '100%' }}>
                                    {item.is_hot == 1 && <img src={ICON_HOT} style={{ width: 28, height: 12, marginTop: 4, marginRight: 8 }} />}
                                    {item.is_hot == 0 && <div style={{ width: 28, height: 12, marginTop: 4, marginRight: 8 }} />}
                                </Grid>
                                <Grid container direction='row' justifyContent='center' style={{ width: '100%' }}>
                                    <img src={item.cover} style={{ width: 80, height: 80 }}></img>
                                </Grid>
                                <Grid container direction='row' style={{ width: '100%', paddingLeft: 8, paddingRight: 8, marginTop: 8 }}>
                                    <Typography noWrap style={{ fontSize: 14, color: '#2F2F2F' }}>{item.name}</Typography>
                                </Grid>
                                <Grid container direction='row' style={{ width: '100%', paddingLeft: 8, paddingRight: 8 }}>
                                    <span style={{ fontSize: 12, color: '#FF0000', marginTop: 4 }}>
                                        {item.score} <span style={{ fontSize: 12, color: '#919191' }}>积分/次</span>
                                    </span>
                                </Grid>

                            </Grid>
                        </ButtonBase>
                    ))
                }
            </Grid>
        );
    }

    _onEndReached = () => {
        let page = this.state.page + 1;
        this.setState({ page: page }, () => {
            this.encryptionGiftList(page);
        })
    }

    renderHeader = () => {
        const { classes } = this.props;
        const { data, dayList, goodsList, showSign, showBuy, curGood, snackopened, message } = this.state;
        let sign_days = data.sign_days ? data.sign_days : 0;
        let next_score = data.next_score ? data.next_score : 0;
        return (
            <Grid container direction='column'>
                <Grid container direction='row' alignItems='center' className={classes.myInfo}>
                    <Grid style={{ paddingLeft: 12 }}>
                        <img src={this.state.avatar} style={{ width: 50, height: 50, borderRadius: 25 }} />
                    </Grid>
                    <Grid style={{ marginLeft: 12 }}>
                        <Typography style={{ fontSize: 14, color: "#0D0D0D" }}>{"已连续签到" + sign_days + "天"}</Typography>
                        <Typography style={{ fontSize: 12, color: "#878787" }}>{"明日签到可获得" + next_score + "积分"}</Typography>
                    </Grid>
                </Grid>
                <Grid container direction='row' alignItems='center' className={classes.dayInfo}>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 12, paddingRight: 12 }}>
                        {
                            dayList && dayList.map((item, i) => (
                                <Grid key={i} container direction='row' alignItems='center' style={{ width: '13vw', marginTop: 12 }}>
                                    <Grid container direction='column' alignItems='center' justifyContent='center'>
                                        <Typography style={{ fontSize: 11, color: "#919191" }}>{item.name}</Typography>
                                        {this.renderGift(item.day, item.sign_status)}
                                    </Grid>
                                </Grid>
                            ))
                        }
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ marginTop: 12, paddingLeft: 12, paddingRight: 12 }}>
                        <Grid style={{ width: 4, height: 4, borderRadius: 2, backgroundColor: '#FECD34' }}></Grid>
                        <Typography style={{ color: '#423201', fontSize: 12, marginLeft: 8 }}>连续签到7天可额外获得积分礼包</Typography>
                    </Grid>
                    <Grid container direction='row' style={{ paddingLeft: 12, paddingRight: 12, marginTop: 10, width: '100%' }}>
                        <Grid container direction='column' alignItems='center' justifyContent='space-between' style={{ backgroundColor: '#FECD34', width: '100%', height: 93, borderRadius: 20 }}>
                            <Grid container direction='column' style={{ width: '50%' }} >
                                <Typography style={{ color: '#423201', fontSize: 10, marginTop: 12 }}>我的积分</Typography>
                                <Typography style={{ color: '#423201', fontSize: 40, }}>{data.score}</Typography>
                            </Grid>
                            <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ width: '30%' }}>
                                <img src={ICON_SPORTS} style={{ width: 48, height: 82 }} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction='row' justifyContent='space-between' style={{ marginTop: 16, marginBottom: 16 }}>
                        <Grid container direction='row' alignItems='center' style={{ width: '50vw', paddingLeft: 24 }}>
                            <ButtonBase onClick={() => this.onDetailClick()}>
                                <img src={ICON_DETAIL} style={{ width: 13.5, height: 15.5 }} />
                                <Typography style={{ fontSize: 13, color: '#919191', marginLeft: 8 }}>积分明细</Typography>
                            </ButtonBase>
                        </Grid>
                        <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ width: '50vw', paddingRight: 24 }}>
                            <ButtonBase onClick={() => this.onRuleClick()}>
                                <img src={ICON_RULE} style={{ width: 16, height: 16 }} />
                                <Typography style={{ fontSize: 13, color: '#919191', marginLeft: 8 }}>规则</Typography>
                            </ButtonBase>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container direction='row' justifyContent='space-between' style={{ paddingLeft: 12, paddingRight: 12, marginTop: 12, marginBottom: 12 }}>
                    <Grid>
                        <Typography style={{ fontSize: 15, color: '#0D0D0D', fontWeight: '500' }}>积分兑换专区</Typography>
                    </Grid>
                    <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ width: '50vw', marginLeft: 12 }}>
                        <ButtonBase onClick={() => this.onMyGoodList()}>
                            <Typography style={{ fontSize: 12, color: '#919191', fontWeight: '400' }}>查看我兑换的商品</Typography>
                            <img src={ICON_ARROW} style={{ width: 5, height: 8, marginLeft: 4 }} />
                        </ButtonBase>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { data, dayList, goodsList, showSign, showBuy, curGood, snackopened, message } = this.state;

        let sign_days = data.sign_days ? data.sign_days : 0;
        let next_score = data.next_score ? data.next_score : 0;
        let today_score = data.today_score ? data.today_score : 0;

        let { nav } = this.props.match.params;
        if (nav && nav == 1) {
            nav = 1
        } else {
            nav = 0
        }



        return (
            //appbar是否隐藏
            <MBack title='积分商城' backgroundColor="#EEEEEE" hideNav={nav} >
                <Grid container    >

                    {
                        this.renderHeader()
                    }

                    <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
                        {
                            goodsList.length > 0 && goodsList.map((item, index) => {
                                return <ButtonBase key={index} onClick={() => this.onItemClick(item)}>
                                    <Grid container direction='column' className={classes.goodItem}>
                                        <Grid container direction='row' justifyContent='flex-end' style={{ width: '100%' }}>
                                            {item.is_hot == 1 && <img src={ICON_HOT} style={{ width: 28, height: 12, marginTop: 4, marginRight: 8 }} />}
                                            {item.is_hot == 0 && <div style={{ width: 28, height: 12, marginTop: 4, marginRight: 8 }} />}
                                        </Grid>
                                        <Grid container direction='row' justifyContent='center' style={{ width: '100%' }}>
                                            <img src={item.cover} style={{ width: 80, height: 80 }}></img>
                                        </Grid>
                                        <Grid container direction='row' style={{ width: '100%', paddingLeft: 8, paddingRight: 8, marginTop: 8 }}>
                                            <Typography noWrap style={{ fontSize: 14, color: '#2F2F2F' }}>{item.name}</Typography>
                                        </Grid>
                                        <Grid container direction='row' style={{ width: '100%', paddingLeft: 8, paddingRight: 8 }}>
                                            <span style={{ fontSize: 12, color: '#FF0000', marginTop: 4 }}>
                                                {item.score} <span style={{ fontSize: 12, color: '#919191' }}>积分/次</span>
                                            </span>
                                        </Grid>

                                    </Grid>
                                </ButtonBase>
                            })
                        }
                    </div>


                </Grid>
                {showSign && <IntegralSign open={showSign} score={today_score} onClose={() => this.setState({ showSign: false })} />}
                {showBuy && <IntegralBuy good={curGood} open={showBuy} onClose={() => this.setState({ showBuy: false })} onExchange={(good) => this.onExchange(good)} />}

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>

            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    top: {
        width: '100vw',
        backgroundColor: theme.palette.background.default,
    },
    dayItem: {
        backgroundColor: "#FECD34",
        width: 25,
        height: 25,
        borderRadius: 12.5,
        marginTop: 8
    },
    dayItem1: {
        backgroundColor: "#FFF",
        width: 25,
        height: 25,
        borderRadius: 12.5,
        marginTop: 8
    },
    dayInfo: {
        marginTop: 12,
        backgroundColor: "#FFF",
        borderRadius: 10,
    },
    myInfo: {
        paddingTop: 36,
        paddingBottom: 24,
        backgroundColor: "#FFF",
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12
    },
    content: {
        margin: theme.spacing(2, 2, 0, 2),
        background: '#007AFF',
        width: 'calc(100vw - 32px)',
        height: 110,
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15
    },
    goodItem: {
        backgroundColor: '#FFF',
        width: 'calc((100vw - 40px)/3)',
        height: 150,
        borderRadius: 10,
        marginBottom: 10,
        marginLeft: 10
    }
}))(IntegralWallet));